var exports = {
  "W": "EyebrowBanner__drKxii",
};

module.exports = exports;
